/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=742b4682&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=742b4682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b4682",
  null
  
)

export default component.exports